const KEYS = {
  ENTER: 'Enter',
  BACKSPACE: 'Backspace'
}

export default KEYS
export { KEYS }
